import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  makeStyles,
  useTheme,
  useMediaQuery,
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import { useState } from "react";
import { useHistory } from "react-router-dom";

import isAuth, { userType } from "../lib/isAuth";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  title: {
    flexGrow: 1,
  },
  menuIcon: {
    color: "#fff",
  },
  drawerList: {
    width: 250,
  },
}));

const Navbar = () => {
  const classes = useStyles();
  const history = useHistory();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleClick = (path) => {
    setDrawerOpen(false); // close drawer
    history.push(path);
  };

  const renderMenuButtons = () => {
    if (isAuth()) {
      if (userType() === "recruiter") {
        return [
          { text: "Home", path: "/home" },
          { text: "Add Jobs", path: "/addjob" },
          { text: "My Jobs", path: "/myjobs" },
          { text: "Employees", path: "/employees" },
          { text: "Profile", path: "/profile" },
          { text: "Logout", path: "/logout" },
        ];
      } else {
        return [
          { text: "Home", path: "/home" },
          { text: "Applications", path: "/applications" },
          { text: "Profile", path: "/profile" },
          { text: "Logout", path: "/logout" },
        ];
      }
    } else {
      return [
        { text: "Login", path: "/login" },
        { text: "Signup", path: "/signup" },
      ];
    }
  };

  return (
    <>
      <AppBar position="fixed">
        <Toolbar>
          <Typography variant="h6" className={classes.title}>
            kashmirlens
          </Typography>

          {isMobile ? (
            <>
              <IconButton edge="end" onClick={() => setDrawerOpen(true)}>
                <MenuIcon className={classes.menuIcon} />
              </IconButton>
              <Drawer
                anchor="right"
                open={drawerOpen}
                onClose={() => setDrawerOpen(false)}
              >
                <List className={classes.drawerList}>
                  {renderMenuButtons().map((item) => (
                    <ListItem button key={item.text} onClick={() => handleClick(item.path)}>
                      <ListItemText primary={item.text} />
                    </ListItem>
                  ))}
                </List>
              </Drawer>
            </>
          ) : (
            renderMenuButtons().map((item) => (
              <Button
                key={item.text}
                color="inherit"
                onClick={() => handleClick(item.path)}
              >
                {item.text}
              </Button>
            ))
          )}
        </Toolbar>
      </AppBar>
    </>
  );
};

export default Navbar;
